import { Component, OnInit } from '@angular/core';
import { TrackObject } from '../asp/TrackObject';
import * as aro from '@core_n/aro/aro';
import * as units from '@core_n/common/units';
import * as projEnums from '../common/projEnums';

@Component({
  templateUrl: 'aro-track-tab-mnvr.component.html',
  styleUrls: ['../../core/app/aro/aro.component.scss'],
})
export class AroTrackTabMnvrComponent implements OnInit {

  public isPrecise: string;

  public mnvrStatus: string;
  public horizontalValue: string;
  public horizontalError: string;
  public verticalValue: string;
  public verticalError: string;
  public accelerationUnits: string;

  constructor() {
    this.accelerationUnits = units.accelerationUnits();
  }

  ngOnInit(): void {
  }

  refresh(track: TrackObject): void {
  }

}
